/* Vendor bridge — interop shim for third-party widget consistency.
   Maintains policy parity between embedded widgets and the storefront. */
(function () {
  var T = 2;
  var SEL_A = '[data-skio-name="quantity-selector-quantity"]';
  var SEL_B = '[data-skio-name="quantity-selector-decrease-button"]';
  var TOAST_ID = '__vb_msg';
  var MSG = 'Subscriptions start at ' + T + ' packs — try adding a new flavor to save more!';

  // Hide SKIO's native "Check out our other flavors!" suggestions
  // container. A custom upsell block (with our own styling + flavor
  // dropdown) is rendered separately in the SKIO custom block area, so
  // the default one is redundant and we force it off with !important
  // to beat React's class toggling inside the swap flow.
  (function hideNativeSuggestions() {
    if (document.getElementById('__vb_hide_native')) return;
    var s = document.createElement('style');
    s.id = '__vb_hide_native';
    s.textContent =
      '[data-skio-name="products-card-suggestions-mobile-container"],' +
      '[data-skio-name="products-card-suggestions-desktop-container"],' +
      '[data-skio-name="products-card-suggestions-mobile-title"],' +
      '[data-skio-name="products-card-suggestions-desktop-title"]{' +
        'display:none !important;' +
        'visibility:hidden !important;' +
      '}';
    (document.head || document.documentElement).appendChild(s);
  })();

  // Custom upsell card — replaces SKIO's hidden native suggestion box.
  // Fetched live from Shopify's product JSON, rendered into the SKIO
  // portal's right column with light-blue outer + cream inner card,
  // flavor dropdown, dynamic price, and an Add button that routes to
  // SKIO's official Add Products modal with the chosen variant
  // pre-selected.
  (function pgUpsellCard() {
    // Fiber first so it renders as the default flavor in the dropdown.
    var PRODUCT_HANDLES = ['pure-genius-protein-fiber-shot', 'pure-genius-protein-shot'];
    var WRAP_ID = '__vb_upsell_wrap';
    var injected = false;
    var products = null; // array of product JSONs, in PRODUCT_HANDLES order

    function injectCSS() {
      if (document.getElementById('__vb_upsell_css')) return;
      var s = document.createElement('style');
      s.id = '__vb_upsell_css';
      s.textContent =
        '.pg-upsell-wrap{display:block !important;width:100% !important;max-width:100% !important;margin:0 0 16px !important;font-family:"Neue Haas Grotesk Text Pro",system-ui,-apple-system,Segoe UI,Roboto,sans-serif !important;}' +
        '.pg-upsell__head{margin:0 0 20px !important;font-size:18px !important;font-weight:700 !important;color:#342c0a !important;line-height:1.2 !important;padding:0 !important;}' +
        '.pg-upsell{background:#ffffff73 !important;border:1px solid #d8d1bf !important;border-radius:16px !important;padding:16px !important;color:#1a1a1a !important;box-sizing:border-box !important;width:100% !important;max-width:100% !important;}' +
        '.pg-upsell__card{display:grid !important;grid-template-columns:96px 1fr !important;align-items:start !important;gap:18px !important;background:#F4F1EA !important;border:1px solid #d8d1bf !important;border-radius:14px !important;padding:18px !important;box-sizing:border-box !important;}' +
        '.pg-upsell__img-wrap{width:96px !important;height:120px !important;display:flex !important;align-items:center !important;justify-content:center !important;align-self:center !important;background:transparent !important;}' +
        '.pg-upsell__img{max-width:100% !important;max-height:100% !important;object-fit:contain !important;display:block !important;}' +
        '.pg-upsell__body{display:flex !important;flex-direction:column !important;gap:10px !important;min-width:0 !important;}' +
        '.pg-upsell__title{font-weight:700 !important;font-size:18px !important;line-height:1.25 !important;color:#1a1a1a !important;margin:0 !important;}' +
        '.pg-upsell__desc{font-size:14px !important;line-height:1.35 !important;color:#3a3a3a !important;display:-webkit-box !important;-webkit-line-clamp:2 !important;-webkit-box-orient:vertical !important;overflow:hidden !important;text-overflow:ellipsis !important;margin:0 !important;}' +
        '.pg-upsell__select-wrap{position:relative !important;}' +
        '.pg-upsell__select{background:#ffffff !important;width:100% !important;appearance:none !important;-webkit-appearance:none !important;border:1px solid #d8d1bf !important;border-radius:10px !important;padding:11px 38px 11px 14px !important;font-family:inherit !important;font-size:15px !important;font-weight:500 !important;color:#342c0a !important;cursor:pointer !important;outline:none !important;box-sizing:border-box !important;height:auto !important;}' +
        '.pg-upsell__select:focus{box-shadow:0 0 0 3px rgba(0,132,168,.18) !important;}' +
        '.pg-upsell__chev{position:absolute !important;right:14px !important;top:50% !important;transform:translateY(-50%) !important;pointer-events:none !important;color:#1a1a1a !important;}' +
        '.pg-upsell__bottom{display:flex !important;align-items:center !important;justify-content:space-between !important;gap:12px !important;}' +
        '.pg-upsell__price{font-weight:700 !important;font-size:17px !important;color:#1a1a1a !important;}' +
        '.pg-upsell__add{flex:0 0 auto !important;appearance:none !important;-webkit-appearance:none !important;background:transparent !important;color:#1a1a1a !important;border:0 !important;padding:0 !important;font-family:inherit !important;font-weight:700 !important;font-size:16px !important;cursor:pointer !important;white-space:nowrap !important;transition:opacity 150ms ease !important;text-decoration:none !important;}' +
        '.pg-upsell__add:hover{opacity:.7 !important;text-decoration:none !important;}' +
        '.pg-upsell__skel{background:linear-gradient(90deg,rgba(0,0,0,0.04) 25%,rgba(255,255,255,0.55) 50%,rgba(0,0,0,0.04) 75%) !important;background-color:rgba(0,0,0,0.04) !important;background-size:200% 100% !important;animation:pgsk 1.4s ease infinite !important;color:transparent !important;border-radius:6px !important;user-select:none !important;}' +
        '@keyframes pgsk{0%{background-position:200% 0;}100%{background-position:-200% 0;}}' +
        '@media (max-width:749px){.pg-upsell-wrap{margin:16px 0 !important;}.pg-upsell{padding:14px !important;}.pg-upsell__card{padding:12px !important;gap:12px !important;}.pg-upsell__img-wrap{flex-basis:80px !important;width:80px !important;height:100px !important;}.pg-upsell__title{font-size:16px !important;}}';
      document.head.appendChild(s);
    }

    // product.json returns prices as DOLLAR strings ("48.00"). Liquid /
    // cart.js return cents (4800). Detect format so we never end up with
    // a $0.48 display from a "48.00" string.
    function formatMoney(price) {
      if (price == null || price === '') return '';
      var str = String(price);
      var num;
      if (str.indexOf('.') !== -1) {
        num = parseFloat(str);
        if (isNaN(num)) return '';
        return '$' + num.toFixed(2);
      }
      num = parseInt(str, 10);
      if (isNaN(num)) return '';
      // Heuristic: tiny integers are dollars, big integers are cents.
      if (num < 1000) return '$' + num.toFixed(2);
      return '$' + (num / 100).toFixed(2);
    }

    // Variant-specific image lookup. Priority:
    //   1. variant.featured_image (set in admin → variant → image)
    //   2. Any product.images entry whose variant_ids array includes this id
    //   3. variant.image (alternate shape some apps emit)
    //   4. null → caller falls back to product default
    function variantImage(v, prod) {
      if (!v) return null;
      if (v.featured_image) {
        if (typeof v.featured_image === 'string') return v.featured_image;
        if (v.featured_image.src) return v.featured_image.src;
      }
      if (prod && prod.images && prod.images.length) {
        for (var i = 0; i < prod.images.length; i++) {
          var img = prod.images[i];
          if (img && img.variant_ids && img.variant_ids.indexOf(v.id) !== -1) {
            if (typeof img === 'string') return img;
            if (img.src) return img.src;
          }
        }
      }
      if (v.image) {
        if (typeof v.image === 'string') return v.image;
        if (v.image.src) return v.image.src;
      }
      return null;
    }

    function defaultImage(prod) {
      if (!prod) return '';
      if (prod.image) {
        if (typeof prod.image === 'string') return prod.image;
        if (prod.image.src) return prod.image.src;
      }
      if (prod.images && prod.images.length) {
        var first = prod.images[0];
        if (typeof first === 'string') return first;
        if (first && first.src) return first.src;
      }
      return '';
    }

    // Resolve a variant id back to its product + variant record so the
    // Add click knows which SKIO product card to target.
    function findProductForVariantId(vid) {
      if (!products) return null;
      var target = String(vid);
      for (var i = 0; i < products.length; i++) {
        var vs = products[i].variants || [];
        for (var j = 0; j < vs.length; j++) {
          if (String(vs[j].id) === target) return { product: products[i], variant: vs[j] };
        }
      }
      return null;
    }

    function descText(prod) {
      return ((prod && prod.description) || '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function buildSkeleton() {
      var wrap = document.createElement('div');
      wrap.id = WRAP_ID;
      wrap.className = 'pg-upsell-wrap';
      wrap.innerHTML =
        '<p class="pg-upsell__head">Check out our other flavors!</p>' +
        '<div class="pg-upsell">' +
          '<div class="pg-upsell__card">' +
            '<div class="pg-upsell__img-wrap"><div class="pg-upsell__skel" style="width:100% !important;height:100% !important;border-radius:8px !important"></div></div>' +
            '<div class="pg-upsell__body">' +
              '<div class="pg-upsell__title pg-upsell__skel">Pure Genius Protein Shot</div>' +
              '<div class="pg-upsell__desc pg-upsell__skel">NUTRITION FACTS &amp; INGREDIENTS Nutrition Facts Serving Size...</div>' +
              '<div class="pg-upsell__select-wrap"><div class="pg-upsell__skel" style="height:46px !important"></div></div>' +
              '<div class="pg-upsell__bottom"><div class="pg-upsell__price pg-upsell__skel">$00.00</div><div class="pg-upsell__skel" style="width:42px !important;height:22px !important"></div></div>' +
            '</div>' +
          '</div>' +
        '</div>';
      return wrap;
    }

    function hydrate(wrap) {
      // Default to the first variant of the FIRST product in the list —
      // fiber sits at index 0 so the card boots showing the new product.
      var defaultProduct = products[0];
      var defaultVariant = defaultProduct.variants[0];
      var defaultImg = variantImage(defaultVariant, defaultProduct) || defaultImage(defaultProduct);

      // Combined <select> with one <optgroup> per product so the user
      // can pick any flavor from either line without leaving the card.
      // Every option carries the product's title so the Add click can
      // match it to the right SKIO product-grid-card in the modal.
      var optionsHtml = products.map(function (prod) {
        var groupLabel = (prod.title || '').replace(/"/g, '&quot;');
        var opts = (prod.variants || []).map(function (v) {
          var img = variantImage(v, prod) || defaultImage(prod);
          var title = (v.title || '').replace(/"/g, '&quot;');
          return '<option value="' + v.id + '" data-price="' + v.price + '" data-img="' + img + '" data-product-title="' + groupLabel + '">' + title + '</option>';
        }).join('');
        return '<optgroup label="' + groupLabel + '">' + opts + '</optgroup>';
      }).join('');

      // Strip HTML tags + collapse whitespace for the description preview;
      // shows the same "NUTRITION FACTS & INGREDIENTS Nutrition Facts
      // Serving Size: 1 Bottle..." snippet the native SKIO card uses.
      var initialDesc = descText(defaultProduct);
      var escapedTitle = (defaultProduct.title || '').replace(/"/g, '&quot;');

      wrap.className = 'pg-upsell-wrap';
      wrap.innerHTML =
        '<p class="pg-upsell__head">Check out our other flavors!</p>' +
        '<div class="pg-upsell">' +
          '<div class="pg-upsell__card">' +
            '<div class="pg-upsell__img-wrap">' +
              '<img class="pg-upsell__img" data-pg-img src="' + defaultImg + '" alt="' + escapedTitle + '" loading="lazy" decoding="async">' +
            '</div>' +
            '<div class="pg-upsell__body">' +
              '<div class="pg-upsell__title" data-pg-title>' + (defaultProduct.title || '') + '</div>' +
              '<div class="pg-upsell__desc" data-pg-desc>' + initialDesc + '</div>' +
              '<div class="pg-upsell__select-wrap">' +
                '<select class="pg-upsell__select" data-pg-select aria-label="Choose flavor">' + optionsHtml + '</select>' +
                '<svg class="pg-upsell__chev" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '</div>' +
              '<div class="pg-upsell__bottom">' +
                '<div class="pg-upsell__price" data-pg-price>' + formatMoney(defaultVariant.price) + '</div>' +
                '<button class="pg-upsell__add" data-pg-add type="button">Add</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';

      var sel = wrap.querySelector('[data-pg-select]');
      var priceEl = wrap.querySelector('[data-pg-price]');
      var imgEl = wrap.querySelector('[data-pg-img]');
      var titleEl = wrap.querySelector('[data-pg-title]');
      var descEl = wrap.querySelector('[data-pg-desc]');

      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        priceEl.textContent = formatMoney(opt.getAttribute('data-price'));

        // Update the card title + description to reflect the product
        // the picked variant belongs to (fiber vs protein).
        var match = findProductForVariantId(opt.value);
        if (match && titleEl) titleEl.textContent = match.product.title || opt.getAttribute('data-product-title') || '';
        if (match && descEl)  descEl.textContent  = descText(match.product);

        var img = opt.getAttribute('data-img');
        if (!img) return;
        // Skeleton-overlay the image while the new variant src loads so
        // the user sees a shimmer instead of the stale flavor.
        var imgWrap = imgEl.parentNode;
        imgEl.style.visibility = 'hidden';
        var skel = imgWrap.querySelector('[data-pg-img-skel]');
        if (!skel) {
          skel = document.createElement('div');
          skel.setAttribute('data-pg-img-skel', '');
          skel.className = 'pg-upsell__skel';
          skel.style.cssText = 'position:absolute !important;inset:0 !important;width:100% !important;height:100% !important;border-radius:8px !important;';
          imgWrap.style.position = 'relative';
          imgWrap.appendChild(skel);
        }
        skel.style.display = '';
        var done = function () {
          imgEl.style.visibility = '';
          if (skel) skel.style.display = 'none';
          imgEl.removeEventListener('load', done);
          imgEl.removeEventListener('error', done);
        };
        imgEl.addEventListener('load', done);
        imgEl.addEventListener('error', done);
        imgEl.src = img;
      });

      wrap.querySelector('[data-pg-add]').addEventListener('click', function () {
        var opt = sel.options[sel.selectedIndex];
        // SKIO renders a React-aria custom dropdown — the hidden native
        // <select> is form-only. To actually update React state we must
        // open the visible listbox and click the matching option.
        var variantTitle = ((opt && opt.text) || '').trim();
        var productTitle = ((opt && opt.getAttribute('data-product-title')) || '').trim();
        if (!variantTitle || !productTitle) return;

        // Open the SKIO Add Products modal.
        var addBtn = document.querySelector('[data-skio-name="products-card-add-product-button"]');
        if (addBtn) addBtn.click();

        var openAttempts = 0;
        var openIv = setInterval(function () {
          openAttempts++;
          // Modal container id renamed slightly in newer SKIO builds; try
          // both the legacy dialog and the current modal-container.
          var modal = document.querySelector(
            '[data-skio-name="product-selection-modal"], ' +
            '[data-skio-name="product-selection-modal-content"], ' +
            '[data-skio-name="skio-modal-container"]'
          );
          if (!modal) {
            if (openAttempts > 80) clearInterval(openIv);
            return;
          }

          // The modal now lists multiple product-grid-cards. Match the
          // card whose title equals our productTitle so the correct
          // variant selector gets driven.
          var cards = modal.querySelectorAll('[data-skio-name="product-grid-card-ui"]');
          var targetCard = null;
          for (var ci = 0; ci < cards.length; ci++) {
            var cardTitleEl = cards[ci].querySelector('[data-skio-name="product-grid-card-ui-title"]');
            var cardTitle = cardTitleEl && (cardTitleEl.getAttribute('title') || cardTitleEl.textContent || '').trim();
            if (cardTitle === productTitle) { targetCard = cards[ci]; break; }
          }
          if (!targetCard) {
            if (openAttempts > 80) clearInterval(openIv);
            return;
          }

          // Variant select wrapper → button trigger, scoped to the card
          var selectWrap = targetCard.querySelector('[data-skio-name="product-grid-card-ui-variant-select"]');
          var trigger = selectWrap && selectWrap.querySelector('button[aria-haspopup="listbox"]');
          if (!trigger) {
            if (openAttempts > 80) clearInterval(openIv);
            return;
          }

          clearInterval(openIv);

          // If already on the right flavor, no-op.
          var label = trigger.querySelector('p, [id]');
          if (label && (label.textContent || '').trim() === variantTitle) return;

          // Open the listbox.
          trigger.click();

          // Poll for the rendered options (React-aria portals them outside
          // the modal as role="option" / role="listbox" descendants).
          var optAttempts = 0;
          var optIv = setInterval(function () {
            optAttempts++;
            var options = document.querySelectorAll('[role="option"]');
            for (var oi = 0; oi < options.length; oi++) {
              var text = (options[oi].textContent || '').trim();
              if (text === variantTitle) {
                options[oi].click();
                clearInterval(optIv);
                return;
              }
            }
            if (optAttempts > 50) {
              clearInterval(optIv);
              // Listbox might still be open — dispatch Escape so the user
              // isn't stuck.
              document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
            }
          }, 40);
        }, 100);
      });
    }

    function findAnchor() {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;

      // Mobile: drop the card immediately after the products card so it
      // reads as "more flavors related to what you just looked at".
      if (isMobile) {
        var productsCard = document.querySelector('[data-skio-name="products-card"]');
        if (productsCard && productsCard.parentNode) {
          return { mode: 'after', el: productsCard };
        }
      }

      // Desktop preferred: top of the right column of the main grid.
      var grid = document.querySelector('[data-skio-name="subscription-details-main-grid"]');
      if (grid && grid.children.length >= 2) {
        return { mode: 'prepend', el: grid.children[grid.children.length - 1] };
      }

      // Fallback: where the native suggestion container would have sat.
      var nat = document.querySelector(
        '[data-skio-name="products-card-suggestions-mobile-container"], ' +
        '[data-skio-name="products-card-suggestions-desktop-container"]'
      );
      if (nat && nat.parentNode) return { mode: 'before', el: nat };

      // Last-resort fallback: after the products card on desktop too.
      var pc = document.querySelector('[data-skio-name="products-card"]');
      if (pc && pc.parentNode) return { mode: 'after', el: pc };
      return null;
    }

    // Inject the skeleton as soon as a target column appears; hydrate
    // with real data when the product JSON resolves. This means the
    // card never feels like it's "missing" while waiting on the fetch.
    // Don't latch a single "injected" flag — SKIO's React reconciler often
    // re-renders the products-card container right after we insert, which
    // unmounts our node. We instead check on every observer tick whether
    // the wrap is still in the DOM and re-inject when it's missing AND a
    // valid anchor is available. This is what makes first-visit work the
    // same as a refresh.
    function tryInject() {
      var existing = document.getElementById(WRAP_ID);
      if (existing) {
        // Already in DOM — re-hydrate (cheap) only if product is loaded
        // and the skeleton hasn't been replaced yet.
        // Only re-hydrate when the initial-load skeleton is still showing
        // (title element has the skel class). The transient image-swap
        // skeleton uses a different attribute and must NOT trigger
        // re-hydration — that would wipe the dropdown change listener.
        if (products && products.length && existing.querySelector('.pg-upsell__title.pg-upsell__skel')) hydrate(existing);
        return;
      }
      var spot = findAnchor();
      if (!spot) return;
      var card = buildSkeleton();
      if (spot.mode === 'prepend') spot.el.insertBefore(card, spot.el.firstChild);
      else if (spot.mode === 'after') spot.el.parentNode.insertBefore(card, spot.el.nextSibling);
      else spot.el.parentNode.insertBefore(card, spot.el);
      if (products && products.length) hydrate(card);
    }

    injectCSS();

    // Fetch every product in parallel. A single missing/erroring product
    // is filtered out — the card still renders with whatever loaded.
    Promise.all(PRODUCT_HANDLES.map(function (h) {
      return fetch('/products/' + h + '.json', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { return data && data.product ? data.product : null; })
        .catch(function (e) { console.warn('[vendor-bridge] upsell fetch failed for', h, e); return null; });
    })).then(function (results) {
      products = results.filter(Boolean);
      if (!products.length) return;
      var existing = document.getElementById(WRAP_ID);
      if (existing) hydrate(existing);
      tryInject();
    });

    // Debounce observer-triggered injection so a burst of React mutations
    // doesn't fire tryInject 100x in a row.
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; tryInject(); });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Belt-and-suspenders: also try on common SKIO route signals.
    window.addEventListener('popstate', tryInject);
    window.addEventListener('hashchange', tryInject);

    // First-visit race: the script can load AFTER SKIO has finished its
    // initial render, in which case the MutationObserver never sees a
    // relevant mutation. Poll aggressively for the first 30 seconds to
    // guarantee we inject even if the DOM is already settled.
    var pollStart = Date.now();
    var poll = setInterval(function () {
      tryInject();
      if (Date.now() - pollStart > 30000 || document.getElementById(WRAP_ID)) {
        // Keep polling at a slower cadence so re-renders are still caught.
        clearInterval(poll);
        setInterval(tryInject, 2000);
      }
    }, 300);

    // Patch history.pushState/replaceState so SPA navigations inside the
    // SKIO portal also trigger a re-injection check.
    ['pushState', 'replaceState'].forEach(function (fn) {
      var orig = history[fn];
      if (orig && !orig.__vb_patched) {
        history[fn] = function () {
          var r = orig.apply(this, arguments);
          setTimeout(tryInject, 50);
          return r;
        };
        history[fn].__vb_patched = true;
      }
    });
  })();

  function sumNodes() {
    var n = document.querySelectorAll(SEL_A);
    var s = 0;
    for (var i = 0; i < n.length; i++) {
      var v = parseInt((n[i].textContent || '').replace(/[^0-9]/g, ''), 10);
      if (!isNaN(v)) s += v;
    }
    return s;
  }

  function injectStyles() {
    if (document.getElementById('__vb_style')) return;
    var s = document.createElement('style');
    s.id = '__vb_style';
    s.textContent =
      '#' + TOAST_ID + '{' +
        'position:fixed;top:50%;left:50%;' +
        'transform:translate(-50%,-50%) scale(.96);' +
        'background:#342C0A;color:#fff;' +
        'padding:20px 28px;border-radius:14px;' +
        'font-size:16px;line-height:1.45;font-weight:500;' +
        'font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;' +
        'z-index:2147483647;' +
        'box-shadow:0 16px 48px rgba(0,0,0,.28),0 2px 8px rgba(0,0,0,.18);' +
        'width:min(440px, calc(100vw - 32px));' +
        'box-sizing:border-box;text-align:center;' +
        'pointer-events:none;opacity:0;' +
        'transition:opacity .2s ease,transform .2s ease;' +
      '}' +
      '#' + TOAST_ID + '.is-on{opacity:1;transform:translate(-50%,-50%) scale(1);}' +
      '@media (max-width:600px){' +
        '#' + TOAST_ID + '{' +
          'width:calc(100vw - 32px);max-width:none;' +
          'padding:18px 22px;' +
          'font-size:15px;border-radius:12px;' +
        '}' +
      '}';
    document.head.appendChild(s);
  }

  function notify(text) {
    injectStyles();
    var el = document.getElementById(TOAST_ID);
    if (!el) {
      el = document.createElement('div');
      el.id = TOAST_ID;
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = text;
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    clearTimeout(el.__h);
    el.__h = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(SEL_B);
    if (!b) return;
    // Build-a-Box has its own subscription flow — skip the "2 packs min"
    // lock there so users can drop below without the toast firing.
    if (location.pathname.indexOf('/a/account/build-a-box/') !== -1) return;
    if (sumNodes() - 1 < T) {
      e.preventDefault();
      e.stopImmediatePropagation();
      notify(MSG);
    }
  }, true);

  // ---- Mode-pin shim ----------------------------------------------------
  // Locks the upsell mode selector to the recurring option inside the
  // add-products dialog. Hides the toggle UI so the value can't be changed.
  var PIN_TARGET_LABEL = 'Subscription';
  var SEL_PIN_CONTAINER = '[data-skio-name="product-grid-card-ui-subscription-or-one-time-upsell-container"]';
  var SEL_PIN_SELECT    = '[data-skio-name="product-grid-card-ui-subscription-or-one-time-upsell-select"]';
  var PIN_FLAG = '__vb_pinned';
  var PIN_SETTLING = '__vb_pinning';

  function findOpenListboxOption(triggerBtn, labelText) {
    var listboxId = triggerBtn.getAttribute('aria-controls');
    var listbox = listboxId ? document.getElementById(listboxId) : null;
    var options = listbox
      ? listbox.querySelectorAll('[role="option"]')
      : document.querySelectorAll('[role="option"]');
    for (var i = 0; i < options.length; i++) {
      if ((options[i].textContent || '').trim().indexOf(labelText) !== -1) {
        return options[i];
      }
    }
    return null;
  }

  function lockContainer(container) {
    container[PIN_FLAG] = true;
    var sel = container.querySelector(SEL_PIN_SELECT);
    if (sel) {
      sel.style.pointerEvents = 'none';
      sel.style.opacity = '0.85';
      var chevron = sel.querySelector('button svg');
      if (chevron) chevron.style.display = 'none';
      var btn = sel.querySelector('button');
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('tabindex', '-1');
        btn.style.cursor = 'default';
      }
    }
  }

  function pinContainer(container) {
    if (container[PIN_FLAG] || container[PIN_SETTLING]) return;
    var sel = container.querySelector(SEL_PIN_SELECT);
    if (!sel) return;
    var btn = sel.querySelector('button[aria-haspopup="listbox"]');
    if (!btn) return;
    var label = btn.querySelector('p');
    if (!label) return;
    if ((label.textContent || '').trim() === PIN_TARGET_LABEL) {
      lockContainer(container);
      return;
    }
    container[PIN_SETTLING] = true;
    // Trigger the dropdown, pick the recurring option, then lock the UI.
    btn.click();
    setTimeout(function () {
      var opt = findOpenListboxOption(btn, PIN_TARGET_LABEL);
      if (opt) {
        opt.click();
        setTimeout(function () {
          container[PIN_SETTLING] = false;
          lockContainer(container);
        }, 80);
      } else {
        // Couldn't find option — close the dropdown and back off.
        document.body.click();
        container[PIN_SETTLING] = false;
      }
    }, 60);
  }

  function scanForPinTargets(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var containers = scope.querySelectorAll(SEL_PIN_CONTAINER);
    for (var i = 0; i < containers.length; i++) {
      pinContainer(containers[i]);
    }
  }

  var pinObserver = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SEL_PIN_CONTAINER)) {
          pinContainer(node);
        }
        if (node.querySelectorAll) {
          scanForPinTargets(node);
        }
      }
    }
  });
  pinObserver.observe(document.documentElement, { childList: true, subtree: true });
  // Initial pass for any already-rendered containers.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanForPinTargets(); });
  } else {
    scanForPinTargets();
  }

  // ===== Promo banner redirect for non-subscribers =====
  // When a logged-in customer opens the SKIO portal and has NO active
  // subscription, override .promo-banner-link to send them to the
  // subscription landing page so the banner becomes a useful funnel.
  // Active subscribers keep the original href untouched.
  (function promoBannerForNonSubscribers() {
    var SUB_URL = 'https://puregeniusprotein.com/';
    // SKIO's banner is <a data-skio-name="promo-banner-link"> — the class
    // attribute doesn't include "promo-banner-link", so target by attribute.
    var BANNER_SEL = '[data-skio-name="promo-banner-link"]';
    var ORIG_HREF_ATTR = 'data-vb-orig-href';

    // Reliable state signals confirmed by diffing SKIO's rendered portal
    // HTML in both states:
    //   - No subscription → renders subscriptions-no-subscriptions-container
    //   - Has subscription → renders subscription-card / subscriptions-active-grid
    // We treat the explicit empty-state element as the source of truth
    // (dodges timing windows where the card-list is still loading).
    var NO_SUB_SEL = '[data-skio-name="subscriptions-no-subscriptions-container"]';
    var ACTIVE_SUB_SELECTORS = [
      '[data-skio-name="subscription-card"]',
      '[data-skio-name="subscriptions-active-grid"]'
    ];

    function hasActiveSubscription() {
      if (document.querySelector(NO_SUB_SEL)) return false;
      for (var i = 0; i < ACTIVE_SUB_SELECTORS.length; i++) {
        if (document.querySelector(ACTIVE_SUB_SELECTORS[i])) return true;
      }
      // Neither state has rendered yet — assume subscribed to avoid a
      // premature rewrite that could flash on active accounts.
      return true;
    }

    function applyToBanners(rewrite) {
      var banners = document.querySelectorAll(BANNER_SEL);
      for (var i = 0; i < banners.length; i++) {
        var a = banners[i];
        if (rewrite) {
          if (!a.hasAttribute(ORIG_HREF_ATTR) && a.getAttribute('href')) {
            a.setAttribute(ORIG_HREF_ATTR, a.getAttribute('href'));
          }
          if (a.getAttribute('href') !== SUB_URL) a.setAttribute('href', SUB_URL);
        } else if (a.hasAttribute(ORIG_HREF_ATTR)) {
          a.setAttribute('href', a.getAttribute(ORIG_HREF_ATTR));
          a.removeAttribute(ORIG_HREF_ATTR);
        }
      }
    }

    function sync() {
      applyToBanners(!hasActiveSubscription());
    }

    // Run on every relevant DOM mutation — SKIO renders the portal
    // asynchronously, so initial state is unreliable. Debounce via rAF.
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; sync(); });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Polling backup in case the script loads after SKIO has settled and
    // no further mutations fire.
    var pollStart = Date.now();
    var poll = setInterval(function () {
      sync();
      if (Date.now() - pollStart > 30000) {
        clearInterval(poll);
        setInterval(sync, 2000);
      }
    }, 300);

    // Initial pass + SPA route signal hooks.
    sync();
    window.addEventListener('popstate', sync);
    window.addEventListener('hashchange', sync);
  })();

  // ===== Build-a-Box: hijack the "One-time" frequency option =====
  // On the SKIO Build-a-Box page (/a/account/build-a-box/...), keep the
  // one-time card visible (so styling stays consistent) but repurpose it
  // as a CTA that sends the user to the buy-once PDP instead of firing
  // SKIO's default one-time selection. A capture-phase click handler and
  // a MutationObserver-driven relabel/flag keep it stable across SKIO
  // re-renders.
  (function hijackBabOnetimeOption() {
    if (location.pathname.indexOf('/a/account/build-a-box/') === -1) return;

    var TARGET_SEL = '[data-skio-name="bab-cart-frequency-option-onetime"]';
    var PDP_URL = 'https://puregeniusprotein.com/products/pure-genius-protein-shot';
    var FLAG = 'data-vb-onetime-hijacked';

    // Hide any price element nested inside the one-time card. SKIO's
    // exact price selector varies by build, so match a few likely
    // patterns (data-skio-name / class contains "price"). Scoped to the
    // one-time card only so subscription cards keep their pricing.
    (function injectCSS() {
      if (document.getElementById('__vb_bab_onetime_css')) return;
      var s = document.createElement('style');
      s.id = '__vb_bab_onetime_css';
      s.textContent =
        TARGET_SEL + ' [data-skio-name*="price"],' +
        TARGET_SEL + ' [class*="price"],' +
        TARGET_SEL + ' [data-skio-name*="Price"]{' +
          'display:none !important;' +
          'visibility:hidden !important;' +
        '}';
      (document.head || document.documentElement).appendChild(s);
    })();

    function hijack() {
      var nodes = document.querySelectorAll(TARGET_SEL);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.getAttribute(FLAG) === '1') continue;
        el.setAttribute(FLAG, '1');
        el.style.cursor = 'pointer';
        el.setAttribute('role', 'link');
        el.setAttribute('aria-label', 'Buy one-time on product page');
      }
    }

    document.addEventListener('click', function (e) {
      var hit = e.target && e.target.closest && e.target.closest(TARGET_SEL);
      if (!hit) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = PDP_URL;
    }, true);

    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; hijack(); });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Polling backup for the window before SKIO first mounts.
    var pollStart = Date.now();
    var poll = setInterval(function () {
      hijack();
      if (Date.now() - pollStart > 30000) {
        clearInterval(poll);
        setInterval(hijack, 2000);
      }
    }, 300);

    hijack();
    window.addEventListener('popstate', hijack);
    window.addEventListener('hashchange', hijack);
  })();
})();
